module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v(" STRANGE FIRE ")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0037-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter2#ii6",
      "id": "tt6"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "978140020518_0007_002.jpg",
      "src": "images/978140020518_0007_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "p0037-02-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#ii6"
    }
  }, [_vm._v("A N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK OF THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")]), _vm._v("? ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("t was the dawn of the twentieth century, in the early morning hours of New Year’s Day 1901. A group of Bible school students had come together hours earlier for a New Year’s Eve"), _c('span', {
    attrs: {
      "id": "page_p0037-03-2_2_prayer"
    }
  }, [_vm._v(" prayer service")]), _vm._v(". But even though it was long past midnight, they were still there—earnestly seeking to experience the presence and power of the Holy Spirit. All of them desperately hoped for something amazing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Over the previous weeks, the students had been intently studying portions of the book of "), _c('span', {
    attrs: {
      "id": "page_p0037-03-2_136_acts"
    }
  }, [_vm._v("Acts")]), _vm._v(". They were particularly interested in what the apostolic record taught about the "), _c('span', {
    attrs: {
      "id": "page_p0037-03-2_2_baptism"
    }
  }, [_vm._v("baptism")]), _vm._v(" of the Holy Spirit—an experience that, in keeping with their "), _c('span', {
    attrs: {
      "id": "page_p0037-03-2_4_wesleyan"
    }
  }, [_vm._v("Wesleyan Holiness background")]), _vm._v(", they believed took place subsequent to conversion. Their study eventually centered on the miraculous phenomenon of speaking in tongues, which the students concluded was the true sign of Spirit baptism."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw1_6",
      "id": "wt1_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" They observed how the apostles had spoken in tongues on the day of Pentecost, as well as Cornelius in Acts 10 and John the Baptist’s former disciples in "), _c('span', {
    attrs: {
      "id": "page_p0037-03-2_65_acts"
    }
  }, [_vm._v("Acts 19")]), _vm._v(". And they wondered: if tongues-speaking was a sign of the Spirit’s presence in apostolic times, maybe the same was still true at the outset of the twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By the time they gathered for a prayer service on New Year’s Eve, they"), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v(" had all arrived at the same two conclusions—namely, speaking in tongues was the sign of Spirit baptism, and the gift of tongues was still available for them to experience. So with heartfelt determination, they pleaded with God to be baptized by His Spirit. Their teacher, a Methodist Holiness minister named Charles Fox Parham, had encouraged them along these lines. And now they were eager to experience the Spirit’s power firsthand.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Sometime in those early morning hours, something extraordinary happened. One of the students, a young woman named Agnes Ozman, asked her teacher to lay hands on her and pray that she would receive the Holy Spirit."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw2_6",
      "id": "wt2_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" What happened next would change the course of modern church history. As Charles Parham later recounted, “I laid my hands upon her and prayed. I had scarcely completed three dozen sentences when a glory fell upon her, a halo seemed to surround her head and face, and she began speaking the Chinese language and was unable to speak English for three days. When she tried to write in English to tell us of her experience she wrote the Chinese.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw3_6",
      "id": "wt3_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ozman’s experience would soon be shared by both her teacher and her fellow students. During the series of revival meetings that followed, more than twenty different languages were reportedly spoken through the Spirit’s supernatural power, including Russian, Japanese, Bulgarian, French, Bohemian, Norwegian, Hungarian, Italian, and Spanish. Charles Parham himself claimed to speak in Swedish as well as other languages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Such was the "), _c('span', {
    attrs: {
      "id": "page_p0038-01-1_8_beginning"
    }
  }, [_vm._v("beginning of")]), _vm._v(" the modern Pentecostal Movement. As Pentecostal historian Vinson Synan explains, “Ozman’s experience thus became the prototype experience for all the millions of Pentecostals who were to follow.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw4_6",
      "id": "wt4_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Within a decade, more than fifty thousand people would experience the same phenomenon as Agnes Ozman. Enthusiasm continued to mushroom, especially on the West Coast, where another of Parham’s students—a man named William J. Seymour—similarly promoted speaking in tongues as the sign of Spirit baptism. No one could have imagined how a simple prayer meeting at a small Bible school in Kansas would change the world. Just over a century later, the Pentecostal and neo-Pentecostal Movements would grow to include more than half a billion charismatic adherents.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("A N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTECOST")]), _vm._v("? ")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Pentecostalism’s beginnings may sound supernatural and even a bit romantic. Charles Parham named his new movement the “"), _c('span', {
    attrs: {
      "id": "page_p0039-02-1_14_apostolic"
    }
  }, [_vm._v("Apostolic Faith Movement")]), _vm._v(",” and he claimed his experiences constituted a new Pentecost."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw5_6",
      "id": "wt5_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" He and his students were convinced they had received the Holy Spirit in the same way as the apostles in "), _c('span', {
    attrs: {
      "id": "page_p0039-02-1_79_acts"
    }
  }, [_vm._v("Acts")]), _vm._v(" 2. Their experiences in 1901 were the spark that lit the fires of the modern Charismatic Movement."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw6_6",
      "id": "wt6_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Further investigation, however, calls the legitimacy of Parham’s claims into serious question on at least three fronts. First, there are conflicting versions of the story, even from the principal participants involved. As noted above, Parham stated that Ozman did not speak in English for three days after her experience, but Ozman reported praying in English after only one day."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw7_6",
      "id": "wt7_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Parham further claimed that Ozman’s experience occurred on New Year’s Eve, while Ozman insisted it happened on New Year’s Day."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw8_6",
      "id": "wt8_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" While Parham took credit for directing his students to the book of Acts before their historic prayer meeting, Ozman contradicted that claim, asserting “she had no part of any Bible study assignment by Parham prior to her tongues speaking experience. In fact she says she pointed students to Acts 2 in answer to their questions about her glossolalic experience.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw9_6",
      "id": "wt9_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Discrepancies like those have caused historians like Martin E. Marty to question key aspects of the story:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Like all such mythically cast stories, these had certain features that remain open to question. In an earlier stratum of testimony Miss Ozman referred to having spoken in tongues three weeks before New Year’s Day, a less neat date, but one which others corroborated. She also claimed that she realized the significance of her speaking only later, but it is known that Parham had instructed her in advance to look for precisely that sign."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw10_6",
      "id": "wt10_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Furthermore, though Agnes Ozman interpreted her experience through the lens of Acts 2, not all her fellow students were convinced. “"), _c('i', [_vm._v("The Topeka Daily Capital")]), _vm._v(" reported that not everyone at the school embraced the new"), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v(" experience. In an interview with the newspaper, S. J. Riggins said of Parham and his fellow students, ‘I believe the whole of them are crazy.’”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw11_6",
      "id": "wt11_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Second, and more important, Charles Parham, Agnes Ozman, and the other students never actually experienced the supernatural sign they were seeking. They were convinced speaking in tongues entailed the miraculous ability to speak in authentic foreign languages, just as the apostles did on the day of Pentecost in Acts 2."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw12_6",
      "id": "wt12_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('i', [_vm._v("That")]), _vm._v(" was the gift they so desperately desired. The “gift” they experienced, however, consisted of nothing more than nonsensical gibberish."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw13_6",
      "id": "wt13_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" This reality became painfully obvious when Parham insisted that Pentecostal missionaries could go to foreign lands without first going to language school."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw14_6",
      "id": "wt14_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He boasted to the "), _c('i', [_vm._v("Topeka State Journal")]), _vm._v(", “The Lord will give us the power of speech to talk to the people of the various nations without having to study them in schools.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw15_6",
      "id": "wt15_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Several weeks later, he told the "), _c('i', [_vm._v("Kansas City Times")]), _vm._v(", “A part of our labor will be to teach the church the uselessness of spending years of time preparing missionaries for work in foreign lands when all they have to do is ask God for power.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw16_6",
      "id": "wt16_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Within weeks, newspapers as far afield as Hawaii were echoing Parham’s promise—embellished, it seems, with a number of baldfaced falsehoods:")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("TOPEKA, May 20.—Rev. Charles F. Parham, of the “College of Bethel,” at Topeka, and his followers are preparing to give the people of the churches some new work along the line of missionary endeavor.")]), _vm._v(" "), _c('p', {
    staticClass: "ext3"
  }, [_vm._v("His plan is to send among the heathen, persons who have been blessed with the “gift of tongues”—a gift which, he says, no others have ever had conferred upon them since apostolic times. His missionaries, as he points out, will have the great advantages of having the languages of the various peoples among whom they work miraculously conferred upon them and will not be put to the trouble of "), _c('span', {
    attrs: {
      "id": "page_p0040-02-1_30_learn"
    }
  }, [_vm._v("learn")]), _vm._v("ing them in the laborious way by which they are acquired by other prospective missionaries.")]), _vm._v(" "), _c('p', {
    staticClass: "ext3"
  }, [_vm._v("[Said Parham:] “. . . There is no doubt that at this time they will have conferred on them the ‘gift of tongues,’ if they are worthy and seek it in faith, believing they will thus be made able to talk to the people whom they "), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("choose to work among in their own language, which will, of course, be an inestimable advantage.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "ext3"
  }, [_vm._v("“The students of Bethel College do not need to study in the old way to learn the languages. They have them conferred on them miraculously. Different ones have already been able to converse with Spaniards, Italians, Bohemians, Hungarians, Germans, and French in their own language. I have no doubt various dialects of the people of India and even the language of the savages of Africa will be received during our meeting in the same way. I expect this gathering to be the greatest since the days of Pentecost.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "97814002051_0041_002.jpg",
      "src": "images/97814002051_0041_002.jpg"
    }
  })])]), _c('p', {
    staticClass: "ext2"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("He claims that he and his disciples have received all the gifts that Christ conferred upon His earliest disciples."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw17_6",
      "id": "wt17_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Unfortunately, that same sort of deliberately embroidered, wildly exaggerated testimony is all too common in charismatic circles even today. But naive people still take such reports at face value, mistaking gullibility for faith.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In spite of Parham’s confident-sounding guarantees, his missionary strategy backfired, rather badly. Jack Hayford and David Moore, charismatic authors, acknowledge the wholesale failure of Parham’s expectations: “Sadly, the idea of xenoglossalalic tongues [i.e. foreign languages] would later prove an embarrassing failure as Pentecostal workers went off to mission fields with their gift of tongues and found their hearers did not understand them.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw18_6",
      "id": "wt18_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Robert Mapes Anderson adds:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("S. C. Todd of the Bible Missionary Society investigated eighteen Pentecostals who went to Japan, China, and India “expecting to preach to the natives in those countries in their own tongue,” and found that by their own admission “in no single instance have [they] been able to do so.” As these and other missionaries returned in disappointment and failure, Pentecostals were compelled to rethink their original view of speaking in tongues."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw19_6",
      "id": "wt19_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("In addition to speaking in tongues, Agnes Ozman and other Pentecostals also "), _c('span', {
    attrs: {
      "id": "page_p0042-01-0_16_amp"
    }
  }, [_vm._v("“wrote in tongues,”")]), _vm._v(" scribbling down what they believed to be characters of a foreign language. Photographs of these messages were published in newspapers like the "), _c('i', [_vm._v("Topeka Daily Capital")]), _vm._v(" and the "), _c('i', [_vm._v("Los Angeles Daily Times.")]), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw20_6",
      "id": "wt20_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" The chicken-scratches resembled no known language and were completely incomprehensible."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw21_6",
      "id": "wt21_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Third, the "), _c('span', {
    attrs: {
      "id": "page_p0042-01-0_33_personal"
    }
  }, [_vm._v("personal character of")]), _vm._v(" Charles Parham calls into question whether the Holy Spirit would spark a worldwide revival through Parham’s ministry. A short time after his students spoke in tongues, in spite of his predictions that massive growth was about to begin, Parham was forced to close the Bible school in Topeka. He traveled to other parts of Kansas and the Midwest, holding healing and revival meetings and gathering disciples. Soon he was claiming more than five thousand devotees."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw22_6",
      "id": "wt22_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" He referred to his growing network of followers as the "), _c('span', {
    attrs: {
      "id": "page_p0042-01-0_15_apostolic"
    }
  }, [_vm._v("Apostolic Faith Movement")]), _vm._v(" (echoing the name of his biweekly magazine, "), _c('i', [_vm._v("Apostolic Faith")]), _vm._v(") and gave himself the title “Projector of the Apostolic Faith Movement.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw23_6",
      "id": "wt23_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the movement barely survived a string of severe blows to Parham’s reputation. In the fall of 1906, he held a series of meetings in Zion, Illinois, and some months later five of his followers there beat a disabled woman to death in an attempt to drive the demon of rheumatism from her. Although Parham himself was long gone from Zion when the woman was killed, the ensuing murder trial garnered nationwide publicity, and newspapers across the nation identified the killers as “members of the Parham cult.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw24_6",
      "id": "wt24_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" When the chief perpetrators of the crime were found guilty, the national media reported, “Other arrests are expected in the case as the result of evidence given at the inquest, and Parham, leader of the cult to which those now in jail belong, may himself be taken under surveillance.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw25_6",
      "id": "wt25_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Parham was not charged in that case, but his name became a synonym for deadly religious fanaticism.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When a young girl in Kansas died because her parents refused medical treatment and instead sought healing through Parham’s ministry, the Pentecostal evangelist was forced to leave Kansas and go to Texas."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw26_6",
      "id": "wt26_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" It was there that he met William J. Seymour, a thirty-five-year-old African American who—after embracing Parham’s teachings on the Holy Spirit and the gift of tongues—subsequently"), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v(" sparked the Azusa Street Revival in Los Angeles in 1906. But their friendship soon soured. When Parham visited Seymour’s work in Southern California, he did not approve of the wild behavior that characterized the meetings."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw27_6",
      "id": "wt27_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" He tried to assert his leadership over the revival but was rebuffed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From there, Parham’s story quickly gets worse. On July 19, 1907, he was arrested at a hotel in San Antonio, Texas, on charges of sodomy. He was released from custody four days later. Though he claimed to be innocent, his opponents alleged that he had written a full confession in exchange for his release."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw28_6",
      "id": "wt28_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" In spite of his protests to the contrary, Parham’s reputation was permanently besmirched, and his influence began to dwindle. As R. G. Robbins explains, “What actually transpired on that hot summer night may never be known, but Parham’s standing suffered irreparable harm, notwithstanding the fact that charges were later dropped. News of the scandal shot through Holiness and Pentecostal circles, delighting Parham’s enemies and disheartening his dwindling cadre of friends. Meanwhile, the Apostolic Faith Movement shattered.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw29_6",
      "id": "wt29_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In a desperate attempt to salvage his reputation, Parham decided he needed to accomplish something truly remarkable to distract from the allegations. He began a fund-raising campaign for an expedition to the Holy Land, on which he promised to find both Noah’s ark and the lost ark of the covenant."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw30_6",
      "id": "wt30_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" But the trip ended before it began. Parham’s biographer, James R. Goff, tells what happened: “After parading the plan before the press and raising sufficient funds, Parham journeyed to New York in December 1908 to board a steamer for Jerusalem. [But] his ticket for the Middle East was never purchased. Parham returned home to Kansas in January 1909 on money loaned to him by a friend. Dejectedly, he explained to his followers that he had been mugged shortly after arriving in New York and never even had an opportunity to buy his ticket.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw31_6",
      "id": "wt31_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like the majority of preachers affiliated with the Holiness Movement in that era, Parham was attracted to doctrines that were marginal, novel, extreme, or totally unorthodox. He was an ardent advocate of "), _c('span', {
    attrs: {
      "id": "page_p0043-02-2_21_conditional"
    }
  }, [_vm._v("conditional immortality")]), _vm._v(" (the idea that the wicked will be annihilated rather than subjected to eternal torment)—and at times he sounded like a universalist."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw32_6",
      "id": "wt32_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" He had an unorthodox view of human fallenness, and he clearly did not understand the bondage of sin. He seemed to believe sinners could redeem themselves"), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v(" with a combination of their own effort and God’s help, and he apparently viewed grace as something God owed to humanity. He taught that sanctification guarantees physical healing and it is therefore an act of unbelief to seek medical treatment for any ailment."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw33_6",
      "id": "wt33_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Parham also advocated a form of Anglo-Israelism,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw34_6",
      "id": "wt34_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" teaching that the western European races (particularly Anglo-Saxon people) descended from the ten tribes of Israel after they were dispersed in the Assyrian captivity—and white Europeans are therefore the true “chosen people.” That view naturally tends to foster racial bigotry."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw35_6",
      "id": "wt35_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Indeed, as time passed, Charles Parham grew increasingly outspoken as an advocate for racial segregation. On one occasion, he asserted that the reason God flooded the world was in response to interracial marriage. The sermon, titled “Creation and Formation,” was printed in the August 13, 1905, edition of the "), _c('i', [_vm._v("Houston Daily Post")]), _vm._v(". In Parham’s own words: “Thus began the woeful intermarriage of races for which cause the flood was sent in punishment, and has ever been followed by plagues and incurable diseases upon the third and fourth generations, the offspring of such marriages. Were time to last and intermarriage continue between the whites, the blacks and the reds of America, consumption and other diseases would soon wipe the mixed bloods off the face of the earth.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw36_6",
      "id": "wt36_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After visiting Azusa Street in 1906 and being repulsed by its emotional excesses, Parham railed against it. But his antagonism also betrayed an inherent racism. “Using crude racial slurs, Parham denounced white women who consorted with black men in worship at the Azusa mission, and deplored that white and black men and women knelt together and fell across one another. Such ‘foolishness,’ he charged, had followed the Azusa work everywhere.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw37_6",
      "id": "wt37_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" By the end of his life, Parham openly endorsed the Ku Klux Klan, publicly praising the organization in 1927. Summarizing Parham’s racist views, Frederick Harris notes that Pentecostalism’s “theological founder, Charles Parham, sympathized with the Ku Klux Klan, racially segregated students at his Bible school in Topeka, preached against the intermingling of races, and believed that Anglo-Saxons were the master race.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw38_6",
      "id": "wt38_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not surprisingly, scandal and opprobrium dogged Parham’s trail, and his reputation suffered. Others within Pentecostal circles soon began to"), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v(" distance themselves from their founder. “Along with concerns over financial management, his eccentric doctrines, and racist attitudes Parham became an embarrassment to the Pentecostal Movement as it grew in the first decades of the twentieth century.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw39_6",
      "id": "wt39_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" But, like it or not, contemporary Pentecostals (and by extension, all charismatics) are stuck with Charles Parham as the theological architect of their movement."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw40_6",
      "id": "wt40_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" As Anthony Thiselton explains, “Charles Parham is widely regarded as the founder of classical Pentecostalism. . . . Parham formulated the classic four marks of Pentecostal theology and experience: salvation, baptism in the Holy Spirit, healing, and expectancy of the ‘second coming’ of Christ.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw41_6",
      "id": "wt41_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All this raises significant questions about the claims of the modern Pentecostal Movement, given the dubious nature of its initial beginnings: from the conflicting testimony of those involved, to the nonsensical nature of the “tongues” that were spoken, to the disreputable character of the movement’s first leader. Added to that, Pentecostalism arose out of the defective soteriology of the nineteenth-century "), _c('span', {
    attrs: {
      "id": "page_p0045-02-1_18_holiness"
    }
  }, [_vm._v("Holiness Movement")]), _vm._v(", of which Charles Parham and William J. Seymour were both part."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw42_6",
      "id": "wt42_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" In spite of passages like 1 John 1:8"), _c('span', {
    attrs: {
      "id": "page_p0045-02-1_45_amp"
    }
  }, [_vm._v("–10")]), _vm._v(", Holiness theology wrongly asserts that believers can experience a “second blessing” sometime after their conversion, at which point they attain to a state of “Christian perfection” in this life."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw43_6",
      "id": "wt43_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Some nineteenth-century Holiness leaders also taught a “third blessing,” which they identified with the “baptism of the Holy Spirit,” and which Pentecostalism subsequently linked with speaking in tongues."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw44_6",
      "id": "wt44_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But here is the point of all this history: "), _c('i', [_vm._v("If the Holy Spirit intended to re-create the day of Pentecost, is this really how He would do it?")]), _vm._v(" Even a basic comparison between what happened in Acts 2 and what took place nineteen centuries later in Topeka, Kansas, highlights striking contrasts between the two events. The original day of Pentecost did not arise from a defective soteriology, nor did it result in contradictory eyewitness accounts. The apostolic "), _c('span', {
    attrs: {
      "id": "page_p0045-02-1_27_gift"
    }
  }, [_vm._v("gift of")]), _vm._v(" tongues was not some form of irrational vocalization. Rather, the apostles miraculously spoke in authentic foreign languages they had never learned ("), _c('span', {
    attrs: {
      "id": "page_p0045-02-1_39_acts"
    }
  }, [_vm._v("Acts 2:9–12")]), _vm._v("). Moreover, the Spirit’s power was not only exhibited in their fervent preaching, but it was also evident in their godly character—as the Spirit continued to sanctify them over the course of their entire lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("The “new Pentecost” of the Charismatic Movement could not have been more different. It grew out of the deficient soteriology of the Holiness Movement; it was marked by inconsistent eyewitness testimony; it produced counterfeit religious experiences; and it was initiated by a disreputable spiritual leader. Such factors call its legitimacy into serious question.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "h3"
  }, [_vm._v("A “N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOUGHT")]), _vm._v("” A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPROACH")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Around the same time that Charles Parham was directing his students to seek tongues as the sign of Spirit baptism, another American minister was encouraging his followers to use positive confession to speak their desires into existence.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("“What I confess, I possess.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw45_6",
      "id": "wt45_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" That slogan, popularized by later Word of Faith preachers, was first coined by Essek William Kenyon—a Free Will Baptist pastor and educator who lived from 1867 to 1948. Though raised in a Methodist household, Kenyon became a Baptist through the influence of popular evangelist A. J. Gordon. But Kenyon was also exposed to the metaphysical cults of the nineteenth century, and he allowed those errors to taint his theology.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In 1892 he attended Emerson College of Oratory in Boston, which specialized in training lecturers for the "), _c('span', {
    attrs: {
      "id": "page_p0046-01-0_1_metaphysical"
    }
  }, [_vm._v("metaphysical science cults")]), _vm._v(" (in particular, New Thought metaphysics)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw46_6",
      "id": "wt46_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v("  New Thought originated a generation earlier through the teachings of Phineas P. Quimby, a New England philosopher, hypnotist, and healer who taught that physical realities could be manipulated and controlled through mental and spiritual means. New Thought teachings emphasized that a higher intelligence or divine force was everywhere present, that human beings possessed a divine nature, that they could use their minds to alter physical reality, and that by thinking correctly they could free themselves from sickness and poverty."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw47_6",
      "id": "wt47_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Quimby’s ideas were popularized by his followers, including Mary Baker Eddy, who incorporated New Thought teaching into the cult of "), _c('span', {
    attrs: {
      "id": "page_p0046-01-0_2_christian"
    }
  }, [_vm._v("Christian Science")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After leaving Emerson College, Kenyon went on to pastor several Baptist"), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v(" churches. In 1898, he started Bethel Bible Institute in Spencer, Massachusetts. He served as the president of the institute until 1923, when he resigned “amid a swirl of controversy that was never made public.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw48_6",
      "id": "wt48_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" Leaving Massachusetts, he came west, settling for several years in Southern California before relocating to Seattle, Washington, in the early 1930s. There he founded New Covenant Baptist Church, established Seattle Bible Institute, and broadcast his teachings via his "), _c('i', [_vm._v("Kenyon’s Church of the Air")]), _vm._v(" radio program. He was not a Pentecostal, but “in his later years he visited Pentecostal meetings and was invited to speak at Aimee Semple McPherson’s famous Angelus Temple in Los Angeles. Although he died just after the end of the Second World War, many of the prominent healing revivalists of the post-war years were clearly influenced by him and quoted his work.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw49_6",
      "id": "wt49_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Trace the doctrinal pedigree of any Word of Faith teacher, and you will find a line that goes back to E. W. Kenyon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Kenyon’s teaching was seriously aberrant on several levels. In his preaching and teaching, he blended core elements of New Thought philosophy with Christian theology—asserting that people can change their physical circumstances simply by making a “positive confession of the word of God.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw50_6",
      "id": "wt50_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" For example, to be healed, believers merely need to declare they already are healed. As Kenyon explained it, “Confession always goes ahead of healing. Don’t watch symptoms, watch the word, and be sure that your confession is bold and vigorous. Don’t listen to people. . . . It is God speaking. You are healed. The word says you are. Don’t listen to the senses. Give the word its place.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw51_6",
      "id": "wt51_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Only those who make a "), _c('i', [_vm._v("positive")]), _vm._v(" confession can expect positive results. Conversely, those who utter words of "), _c('span', {
    attrs: {
      "id": "page_p0047-01-1_13_pessimism"
    }
  }, [_vm._v("pessimism")]), _vm._v(" are doomed to failure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To cite from Kenyon again, “You will seldom rise above your words. If you talk sickness you will go to the level of your conversation. If you talk weakness and failure you will act it. You keep saying, ‘I can’t get work,’ or ‘I can’t do this,’ and your words react to your body. Why is this? It is because you are a spirit being. You are not a physical being. Basically you are a spirit and spirit registers words just as a piece of blotting paper takes ink.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw52_6",
      "id": "wt52_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" By emphasizing the creative power of words and the notion that disease is spiritual, not physical, Kenyon provided the basic premise for later Word of Faith theology."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw53_6",
      "id": "wt53_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Kenyon’s teachings also laid the foundation for the Word of Faith"), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v(" emphasis regarding material prosperity. For him, the gospel not only offered the hope of future reward in heaven but also promised material blessing on earth, here and now. He wrote, “The value of Christianity is what we get out of it. "), _c('i', [_vm._v("We are Christians for what we can get in this life")]), _vm._v(", and we claim a hope of a world to come. . . . We also "), _c('i', [_vm._v("demand")]), _vm._v(" that the God we serve and worship shall hear our petitions, protect us in danger, comfort us in sorrow.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw54_6",
      "id": "wt54_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" According to Kenyon, “God never planned that we should live in poverty, physical, mental or spiritual. He made Israel go to the head of the nations financially. When we go into partnership with Him, and we learn His ways of doing business, we cannot be failures. . . . He will give you the ability to make your life a success.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw55_6",
      "id": "wt55_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" If such statements sound eerily similar to the modern drivel pumped out by prosperity preachers and mainline televangelists, it should. They got their material from Kenyon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His novel ideas soon infiltrated the Charismatic Movement, where they gave birth to the charismatic "), _c('span', {
    attrs: {
      "id": "page_p0048-01-1_17_word"
    }
  }, [_vm._v("Word of Faith Movement")]), _vm._v(". As Dennis Hollinger notes, “Various Pentecostal healing revivalists of the 1940s and 1950s had read Kenyon’s works and at times quoted from him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw56_6",
      "id": "wt56_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "page_p0048-01-1_1_faith"
    }
  }, [_vm._v("Faith healers")]), _vm._v(" like William Branham and Oral Roberts laid a foundation on which the prosperity gospel might be received within charismatic circles."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw57_6",
      "id": "wt57_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" But it was Kenneth Hagin, widely known as the “father of the Word of Faith Movement,” who popularized Kenyon’s work—even plagiarizing large sections of Kenyon’s writings in his own books."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw58_6",
      "id": "wt58_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Subsequent prosperity preachers—from Kenneth Copeland to Benny Hinn to Creflo Dollar—have all been influenced by Hagin. And as we saw in the previous chapter, the prosperity gospel has become "), _c('i', [_vm._v("the dominant force")]), _vm._v(" in modern Pentecostal and charismatic circles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the same way that Charles Parham’s personal character casts a dark shadow of suspicion over the beginnings of the Pentecostal Movement, E. W. Kenyon’s incorporation of New Thought principles betrays the true origins of the Word of Faith Movement and the prosperity gospel. For Parham, who expected to speak in authentic foreign languages, his initial experience was a counterfeit. For Kenyon, who integrated metaphysical philosophy into his sermons, his resulting theology was cultic. The Word of Faith teachers who follow in Kenyon’s footsteps owe their ancestry to men like Phineas P."), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v(" Quimby—meaning their theology belongs to the same family as Christian Science, Theosophy, Mesmerism, Science of the Mind, Swedenborgianism, and New Thought metaphysics. The resulting prosperity gospel is a mongrel blend of neo-Gnostic dualism, New Age mysticism, and shameless materialism. It is a “destructive heresy” (2 Peter 2:1) that claims health and wealth while leaving its victims morally destitute and spiritually bankrupt.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Why focus on the contributions of Charles Parham and E. W. Kenyon? The answer is simple. These two men are responsible for the theological foundations upon which the entire charismatic system is built. They represent its historic roots. As the founder and theological architect of Pentecostalism, Parham articulated the principles and interpreted the experiences that sparked the modern Charismatic Movement; thus his errors and failures call into question the foundation on which the entire system is built. As the grandfather of the Word of Faith Movement, Kenyon provided later prosperity preachers with a recipe for doctrinal poison. His connection to the metaphysical cults explains the sugarcoated corruption inherent in the popular messages of today’s televangelists.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("A N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAKENING")]), _vm._v("?")])]), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("In spite of its dubious beginnings, the modern Charismatic Movement has mushroomed into a massive entity. Its unprecedented growth has caused some observers to declare it a “new Reformation.” In the words of one scholar, “Christianity is living through a reformation that will prove even more basic and more sweeping than the one that shook Europe during the sixteenth century. . . . The present reformation is shaking foundations more dramatically than its sixteenth-century predecessor, and its results will be more far-reaching and radical.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw59_6",
      "id": "wt59_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" Another author similarly exclaims, “We are now in the midst of one of the most dramatic shifts in Christianity since the Reformation. Christianity is on the move and is creating a seismic change that is changing the face of the whole Christian movement.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw60_6",
      "id": "wt60_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Others have more modestly labeled the modern Charismatic Movement a"), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v(" new Great Awakening. As Vinson Synan explains, “Some historians speak of the Azusa Street Revival of 1906–1909 as the ‘Fourth Great Awakening.’ More than a million Pentecostal congregations were brought into being around the world as a result of this historic revival. Also proceeding from the Pentecostal Movement was the Charismatic Renewal Movement; it began in 1960 and extended the ‘Holy Spirit Renewal’ to both Protestant and Catholic mainline churches in all parts of the world.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw61_6",
      "id": "wt61_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" It is not uncommon for charismatics to make connections between their movement and the Great Awakening of the eighteenth century."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw62_6",
      "id": "wt62_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" In part, this is due to the popularity of the New England revival, which took place in the late 1730s and early 1740s under the leadership of notable preachers and theologians like George Whitefield and Jonathan Edwards.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But parallels are also drawn with the emotional outbursts that sometimes characterized the eighteenth-century revival meetings."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw63_6",
      "id": "wt63_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" During the "), _c('span', {
    attrs: {
      "id": "page_p0050-01-1_26_great"
    }
  }, [_vm._v("Great Awakening")]), _vm._v(", “people wept in repentance for their sins, some shouted for joy at having been pardoned, and a few were so overwhelmed that they fainted.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw64_6",
      "id": "wt64_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" In some cases, the outbursts were even more extreme. As Douglas Jacobsen explains, “During the Great Awakening that took place in colonial America, people sometimes shook with convulsions, cried out with animal-like grunts and shrieks, or fell into trance-like states. . . . These kinds of physical manifestations of spiritual struggle and release were not invented by pentecostals; spiritual physicality is part of the longer history of revivalism.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw65_6",
      "id": "wt65_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Understandably, many of the New England Puritans were skeptical of the revival because of the emotionalism that seemed to accompany it. Among them was a Boston pastor, Charles Chauncy, who complained that “religion, of late, has been more a commotion in the passions, than a change in the temper of the mind.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw66_6",
      "id": "wt66_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" In his 1742 sermon “Enthusiasm Described and Cautioned Against,” Chauncy railed against the Great Awakening, arguing that the revival had exchanged true spirituality for unrestrained sensationalism. His later book, "), _c('i', [_vm._v("Seasoned Thoughts on the State of Religion in New England")]), _vm._v(", echoed those same themes, condemning what he considered to be the religious excess that took place in revival meetings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan Edwards, an avid supporter of the Great Awakening, was well"), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v(" aware of the concerns raised by Charles Chauncy and other “old light” Puritans. In July 1741, when Edwards preached his most famous sermon, “Sinners in the Hands of an Angry God,” the response of the crowd was so intense he couldn’t even finish his message. As George Marsden reports, “The tumult became too great as the audience was overcome by screaming, moanings, and crying out: ‘What shall I do to be saved? Oh I am going to Hell. Oh what shall I do for Christ?’”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw67_6",
      "id": "wt67_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just a couple of days earlier, Edwards preached at a communion service in Suffield, Connecticut. The response was equally emotional. “A visitor who arrived after the sermon said that from a quarter-mile away he could hear howling, screeching, and groaning ‘as of women in the pains of childbirth’ as people agonized over the states of their souls. Some fainted or were in trances; others were overcome with extraordinary bodily shaking. Edwards and others prayed with many of the distraught and brought some to ‘different degrees of peace and joy, some to rapture, all extolling the Lord Jesus Christ’ and urged others to come to the Redeemer.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw68_6",
      "id": "wt68_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In defending the Great Awakening from its critics, Edwards recognized he needed to address their concerns about these kinds of emotional outbursts. He did so in the late summer of 1741, dealing directly with the topic in a commencement message he delivered at his alma mater, Yale College."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw69_6",
      "id": "wt69_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" In his message, which was later published as "), _c('i', [_vm._v("The Distinguishing Marks of a Work of the Spirit of God")]), _vm._v(", Edwards explained that the legitimacy of a revival could not be determined on the basis of emotional responses:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Edwards argued with his usually lucid logic that intense physical phenomena such as “tears, trembling, groans, loud outcries, agonies of body or the failing of bodily strength” did not prove anything one way or the other about the legitimacy of a revival. He did not think that a time of extraordinary gifts of the Holy Spirit had arrived, so he denied (contrary both to some radicals of his day and to later Pentecostals) that ecstatic signs were the best evidence of a true outpouring of the Holy Spirit. At the same time, he insisted, neither were overwhelming emotional outbursts evidences "), _c('i', [_vm._v("against")]), _vm._v(" the presence of the Holy Spirit. . . . The real tests or “distinguishing marks” of a genuine "), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("work of the Spirit of God had nothing to do with such dramatic effects or lack thereof. Rather, these tests were found in the changed lives of those who were now living according to the dictates of the gospel and manifested the traits and virtues of true Christians."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw70_6",
      "id": "wt70_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finding his “distinguishing marks” in the first epistle of John, Edwards contended that a true work of the Holy Spirit can only be measured on the basis of biblical criteria. Emotional experiences may be powerful, but they are no proof that God is truly at work."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw71_6",
      "id": "wt71_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" After all, Edwards recognized that “enthusiasm often spread even when evangelists proclaimed false doctrine. And Satan could simulate true awakenings.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw72_6",
      "id": "wt72_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As Edwards articulated genuine signs of the Spirit’s work, he also delineated “negative signs,” or false positives—signs that "), _c('i', [_vm._v("might")]), _vm._v(" accompany a true work of God but could also be fabricated by hypocrites."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw73_6",
      "id": "wt73_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Edwards placed emotional outbursts and physical responses to preaching in that nondeterminative category: by themselves, such phenomena simply do not prove the legitimacy of a revival."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw74_6",
      "id": "wt74_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How, then, can one discern a true revival from a false one? Or, more directly, what differentiates a true work of the Spirit from a counterfeit? The answer, Edwards contended, is found by “testing the spirits.” Borrowing that phrase from 1 "), _c('span', {
    attrs: {
      "id": "page_p0052-02-1_11_john"
    }
  }, [_vm._v("John 4:")]), _vm._v("1, the Puritan theologian extracted five principles from the fourth chapter of John’s epistle, and thereby developed a distinctly biblical grid that can be applied to any supposed work of God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw75_6",
      "id": "wt75_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thus, Edwards evaluated the experiences of his day through the lens of Scripture, bringing biblical principles to bear on the biggest religious controversy of that time period. For that reason, his approach provides a helpful pattern for us to consider. As R. C. Sproul and Archie Parrish explain:")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("When signs of revival appear on the landscape of history, one of the first questions that is raised is that of authenticity. Is the revival genuine, or is it a mere outburst of superficial emotion? Do we find empty enthusiasm backed by nothing of substance, or does the enthusiasm itself signal a major work of God? In every recorded revival in church history, the signs that follow it are "), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("mixed. The gold is always mixed with dross. Every revival has its counterfeits; distortions tend to raise questions about the real.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('p', {
    staticClass: "ext2"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("This problem certainly attended the eighteenth-century Great Awakening in New England, in which Jonathan Edwards was a key figure. His "), _c('i', [_vm._v("Distinguishing Marks")]), _vm._v(" provides a careful analysis of that revival, noting its substance as well as its excesses. But the Puritan divine’s study of the matter has more relevance than its application to that singular awakening. It provides a map to follow for all such periods of revival and for that reason is of abiding value for us today."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw76_6",
      "id": "wt76_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In Jonathan Edwards’s day, American Christians were trying to determine whether the Great Awakening was a true work of the Holy Spirit. Edwards responded by searching the Scriptures in order to make such an evaluation. He expressed his goal like this: “In the apostolic age there was the greatest outpouring of the Spirit of God that ever was. But as the influences of the true Spirit abounded, counterfeits also abounded. The devil was abundant in mimicking both the ordinary and extraordinary influences of the Spirit of God. This made it very necessary that the church of Christ should be furnished with some certain rules—distinguishing and clear marks—by which she might proceed safely in judging of the true from the false. The giving of such rules is the plain design of 1 "), _c('span', {
    attrs: {
      "id": "page_p0053-02-2_67_john"
    }
  }, [_vm._v("John")]), _vm._v(" 4, where this matter is more expressly and fully treated than anywhere else in the Bible. In this extraordinary day, when there is so much talk about the work of the Spirit, we must carefully apply these principles.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw77_6",
      "id": "wt77_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Similarly, many believers today wonder whether the modern Charismatic Movement represents a true work of the Holy Spirit. As we have seen in this chapter, the historic roots of the movement leave much to be desired. But what about its fruit (cf. Matt. 7:15–20)?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan Edwards went to the Word of God to make his evaluation. Because the Spirit-inspired Scriptures are timeless, we can use those same biblical truths to evaluate the modern Charismatic Movement. In the following chapters, we will consider the fivefold test Edwards derived from 1 John 4—allowing the principles of God’s Word to help us answer the question: "), _c('i', [_vm._v("Does the modern Charismatic Movement represent a true work of the Holy Spirit?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606f3edf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter6.vue
// module id = 81
// module chunks = 0